/* eslint-disable react/react-in-jsx-scope */
import { message } from 'antd';
import {
  getTableData,
  searchList,
  removeMemober,
  sort,
} from '../../services/department/deptMember';
import { setNanoId } from '@/utils/nanoId';
import { userDetails } from '../../services/addressList/addressList';
import { setSpinProps } from '@/utils/utils';

const initState = () => {
  return {
    currentDeptId: '', // 当前部门的id
    columns: [],
    /**
     * userId: string 用户id
     * userName: string 用户名称
     * sex: 性别
     * userSign:  职工号
     * birthday: 生日
     * mobiles: 电话
     */
    data: [],
    currentPage: 1, // 当前页码
    // table选中的项
    selectedRowKeys: [],
    tableId: setNanoId({ str: 'tableKey' }),
    // 调整顺序开关
    isDragPattern: false,
    // 加载状态
    spinProps: {
      spinning: false,
      tip: '加载中...',
    },
    showUserDetailsModal: false,
    userDetails: {},
  };
};

export default {
  namespace: 'countyDeptMember',

  state: initState(),

  effects: {
    // 获取下级部门列表数据
    *fetchList({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { headers, userList } = yield call(getTableData, searchParams);

        const newHeaders = headers.map(item => {
          const newItem = item;

          if (newItem.dataIndex === 'userName') {
            newItem.width = 150;
            newItem.render = text => <div className="table-th-icon">{text}</div>;
          }

          if (newItem.dataIndex === 'followStatus') {
            newItem.render = status => (
              <div className={`table-th-follow-status-${status === 1 ? '1' : '0'}`}>
                {status === 1 ? '已关注' : '未关注'}
              </div>
            );
          }

          return {
            ...newItem,
          };
        });

        yield put({
          type: 'save',
          payload: {
            data: userList,
            tableId: setNanoId({ str: 'tableKey' }),
            columns: [...newHeaders],
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 获取下级部门列表数据
    *fetchSearch({ searchParams }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '加载中...' });

        const { rows } = yield call(searchList, searchParams);

        yield put({
          type: 'save',
          payload: {
            data: rows,
            tableId: setNanoId({ str: 'tableKey' }),
            spinProps: {
              spinning: false,
            },
          },
        });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 移除部门成员
    *removeMember({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '移除中...' });

        yield call(removeMemober, params);

        yield put({
          type: 'save',
          payload: {
            selectedRowKeys: [],
            tableId: setNanoId({ str: 'tableKey' }),
            spinProps: {
              spinning: false,
            },
          },
        });

        message.success('移除部门成功');
        if (callback) {
          setTimeout(() => {
            callback();
          }, 300);
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 排序
    *fetchSort({ params, callback }, { call, put }) {
      try {
        yield setSpinProps({ put, spinning: true, tip: '保存中...' });

        yield call(sort, params);

        yield setSpinProps({ put });

        if (callback) {
          callback();
        }
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
    // 点击用户名称  获取用户详情  弹出用户信息modal
    *fetchUserDetils({ params }, { call, put }) {
      try {
        const { userId } = params;
        const visible = userId && userId.length > 0;
        let data;
        if (visible) {
          yield setSpinProps({ put, spinning: true, tip: '加载...' });

          data = yield call(userDetails, {
            ...params,
          });
        }

        yield put({
          type: 'save',
          payload: { showUserDetailsModal: visible, userDetails: data },
        });
        yield setSpinProps({ put });
      } catch (error) {
        console.error(error);
        yield setSpinProps({ put });
      }
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    reset() {
      return { ...initState() };
    },
  },
};
